import React, { FC, useEffect, useMemo } from "react";
import { Form, FormRenderProps, useFormState } from "react-final-form";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import queryString from "querystring";
import { replaceForFilterForm } from "../helpers/parseFilterToUrlOptions";

const useStyles = makeStyles(() => ({
  root: {
    width: 340,
    padding: "24px 16px",
    borderRadius: 15,
    backgroundColor: "#ffffff",
    boxShadow: "0 0 8px #C2C9D682",
    top: 115,
    position: "sticky",
  },
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#231F20",
    lineHeight: "29px",
  },
  subTitle: {
    fontSize: 14,
    color: "#231F20",
    lineHeight: "17px",
    marginTop: 11,
  },
}));

const FilterFormWrapper: FC<FormRenderProps & { filterForm: FC }> = ({
  handleSubmit,
  filterForm: FilterForm,
}) => {
  const { values } = useFormState();

  useEffect(() => {
    handleSubmit(values);
  }, [values]);

  return (
    <form>
      <FilterForm />
    </form>
  );
};

const LanguageCoursesFilter = ({ submitHandler, filterForm }) => {
  const classes = useStyles();

  const location = useLocation();

  let initialValues = useMemo(() => {
    let queryParams = queryString.parse(
      location.search.split("?").join(""),
      " ",
    );

    if (typeof queryParams.filters === "string") {
      let filters = JSON.parse(queryParams.filters);

      if (Object.keys(filters).length > 0) {
        return replaceForFilterForm(filters);
      }
    }

    return {};
  }, []);

  useEffect(() => {
    submitHandler(initialValues);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography className={classes.title} component={"h1"}>
          Courses
        </Typography>
        <Typography className={classes.subTitle} component={"h2"}>
          Search for Courses
        </Typography>
      </div>
      <Form
        initialValues={initialValues}
        onSubmit={submitHandler}
        keepDirtyOnReinitialize
        render={(props) => (
          <FilterFormWrapper {...props} filterForm={filterForm} />
        )}
      />
    </div>
  );
};

export default React.memo(LanguageCoursesFilter);
